module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6bWXE"))).then(() => parcelRequire('2KbAe'));